import { render, staticRenderFns } from "./ActivatedTab.vue?vue&type=template&id=47432f2d&scoped=true&"
import script from "./ActivatedTab.vue?vue&type=script&lang=js&"
export * from "./ActivatedTab.vue?vue&type=script&lang=js&"
import style0 from "./ActivatedTab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ActivatedTab.vue?vue&type=style&index=1&id=47432f2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47432f2d",
  null
  
)

export default component.exports